import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import Label from 'oxyrion-ui/lib/Label/Label';
import styled from 'styled-components';
import { connect, actions } from '../../Store';
import PopUpWrapper from '../PopUpWrapper';
import { __ } from '../../Utils';
import ProductQuantitySelect from '../ProductQuantitySelect';
import Complementars from '../../Containers/ProductCatalog/Components/Complementars ';
import AlertPopup from '../AlertPopup';
import PriceOffersPopup from '../PriceOffersPopup';
import API2 from '../../API2';

const Wrapper = styled.div`
  z-index: 2000;
`;

const ComplementarsWrapper = styled.div`
  padding: ${rem(20)};
`;

class AddToCartWidget extends React.Component {
  state = {
    showAdd: false,
    showCertificateError: false,
    complementaryLoading: false,
    addedQuantity: 1,
    cartItems: [],
    cartItemsIds: [],
    error: false,
  };

  async componentWillReceiveProps(nextProps) {
    if (
      (nextProps.product && !this.props.product) ||
      (nextProps.product &&
        this.props.product &&
        nextProps.product._id !== this.props.product._id)
    ) {
      if (
        nextProps.catalogProductParams &&
        nextProps.catalogProductParams.length &&
        nextProps.catalogProductParams.find(
          p => p.system_name === 'security_certificates',
        )
      ) {
        const productCert = nextProps.catalogProductParams.find(
          p => p.system_name === 'security_certificates',
        );

        const certs = await API2.getB2BCustomerSecurityCertificatesAction(
          nextProps.user.firm,
          nextProps.user.customer._id,
          { onlyValid: true },
        );

        if (this.validateCertificates(productCert.value, certs.items)) {
          this.setState({
            showAdd: true,
            addLoading: false,
            addedQuantity: nextProps.quantity,
          });
        } else {
          this.setState({
            showCertificateError: true,
          });
        }
      } else {
        this.setState({
          showAdd: true,
          addLoading: false,
          addedQuantity: nextProps.quantity,
        });
      }
    }
  }

  validateCertificates(productCerts = [], userCerts = []) {
    // eslint-disable-next-line no-restricted-syntax
    for (const cert of productCerts) {
      if (!userCerts.find(m => m.certificateTypeId === cert.value)) {
        return false;
      }
    }

    return true;
  }

  async addComplementarsToCard(id, quantity, forced) {
    try {
      const { activeCart, product } = this.props;
      const myCarts = await API2.getCartsAction();
      const selectedCart = myCarts.carts.find(c => c._id === activeCart);

      this.setState({
        complementaryLoading: true,
      });

      const cartResult = await API2.postCartItemAction(selectedCart._id, {
        body: {
          product_id: id,
          quantity: Number(quantity),
          offer_id: product.offer_id && product.offer_id,
          is_wh010_sale: product.is_wh010_sale,
        },
        addToExistingItem: forced,
      });
      this.setState(
        {
          showComplementaryAdded: true,
          showComplementarsProducts: false,
          complementaryLoading: false,
        },
        () => this.props.callback(cartResult.cart.items),
      );

      actions.updateCarts(cartResult.cart);
    } catch (e) {
      if (e.response.status === 409) {
        if (e.details.name === 'SECURITY_CERTIFICATE_REQUIREMENT') {
          this.setState({
            showCertificateError: true,
          });
        } else {
          this.setState({
            showAdd: false,
            compToAdId: id,
            quantityToForcedCompAdd: quantity,
            compError: __('Produkt sa už nachádza v košíku'),
          });
        }
      }
    }
  }

  handleKeyDown(e, quantity) {
    if (e.key === 'Enter' && quantity > 0) {
      this.addToCard(quantity);
    }
  }

  async addToCard(quantity, forced = false, priceOfferId = null) {
    const {
      product,
      colorCode,
      toningSystemId,
      colorCardId,
      activeCart,
      priceOffers,
    } = this.props;

    const filteredpriceOffers = priceOffers.filter(
      d => d.quantity === -1 || quantity <= d.quantity,
    );

    if (
      filteredpriceOffers &&
      filteredpriceOffers.length > 0 &&
      priceOfferId === null
    ) {
      this.setState({
        priceOfferQuantity: quantity,
        showPriceOffers: true,
      });

      return;
    }

    this.setState({
      addLoading: true,
      showPriceOffers: false,
    });

    const myCarts = await API2.getCartsAction();
    const selectedCart = myCarts.carts.find(c => c._id === activeCart);

    if (product) {
      try {
        let cartToLoad = selectedCart;

        if (!selectedCart) {
          cartToLoad = await API2.createCartAction({
            body: { title: 'cart1' },
          });
        }

        console.log('product---', product);

        const dataToSend = {
          quantity,
          product_id: product._id,
          is_wh010_sale: product.is_wh010_sale,
          is_sale: product.is_sale,
        };

        if (product.offer_id) {
          dataToSend.offer_id = product.offer_id;
        }

        if (priceOfferId && priceOfferId !== 'WITHOUT') {
          dataToSend.offer_id = priceOfferId;
        }

        if (
          colorCode &&
          toningSystemId &&
          colorCardId &&
          (!product.finished_shade || !product.finished_shade.length)
        ) {
          if (colorCode) {
            dataToSend.color_code = colorCode;
            dataToSend.toningSystemId = toningSystemId;
            dataToSend.colorCardId = colorCardId;
          }
          dataToSend.coefficient =
            product.variantParams &&
            product.variantParams.find(vp => vp.name === 'Koeficient tónovania')
              ? Number(
                  product.variantParams.find(
                    vp => vp.name === 'Koeficient tónovania',
                  ).value,
                ) || 1
              : product.coefficient || 1;
        }

        const cartResult = await API2.postCartItemAction(cartToLoad._id, {
          body: dataToSend,
          addToExistingItem: forced,
        });

        actions.updateCarts(cartResult.cart);

        this.setState(
          {
            showAdd: false,
            showPriceOffers: false,
            addLoading: false,
            cartItems: cartResult.cart.items,
            cartItemsIds: cartResult.cart.items.map(item => {
              return item.product_id;
            }),
            complementarsProducts: cartResult.complementarsProducts,
            showComplementarsProducts:
              cartResult.complementarsProducts.length > 0,
            addedQuantity: quantity,
          },
          () => {
            if (!cartResult.complementarsProducts.length > 0) {
              this.props.callback(cartResult.cart.items);
            }
          },
        );
      } catch (e) {
        console.log(e);
        console.log(e.details.name);
        console.log(e.details.payload);
        if (
          e.response.status === 409 &&
          e.details.name === 'SALE_STOCK_LIMIT'
        ) {
          this.setState({
            showAdd: false,
            maxSaleQuantity: e.details.payload.max_quantity,
          });
        } else if (e.response.status === 409) {
          this.setState({
            showAdd: false,
            quantityToForcedAdd: quantity,
            error: __('Produkt sa už nachádza v košíku'),
          });
        } else {
          console.log(e);
        }
      }
    }
  }

  render() {
    const { product, closeCallBack, priceOffers } = this.props;
    const {
      showAdd,
      addLoading,
      complementaryLoading,
      showComplementarsProducts,
      cartItems,
      cartItemsIds,
      complementarsProducts,
      addedQuantity,
      error,
      compError,
      quantityToForcedAdd,
      compToAdId,
      quantityToForcedCompAdd,
      showPriceOffers,
      priceOfferQuantity,
      showCertificateError,
      maxSaleQuantity,
    } = this.state;

    return (
      <Wrapper>
        <AlertPopup
          alert
          fullWidth={false}
          display={showCertificateError}
          text={__('Potrebný certifikát')}
          subText={__(
            'Na nákup tohto produktu nemáte priradený správny certifikát. Chcete pridať certifikát?',
          )}
          alignUnderHeader
          onSubmit={() => {
            this.props.history.push('/settings/certificates/new');
          }}
          onDismiss={() =>
            this.setState(
              {
                showCertificateError: false,
              },
              () => closeCallBack(),
            )
          }
          onClose={() =>
            this.setState(
              {
                showCertificateError: false,
              },
              () => closeCallBack(),
            )
          }
        />
        <PriceOffersPopup
          display={showPriceOffers}
          onClose={() =>
            this.setState({
              showPriceOffers: false,
            })
          }
          onSubmit={priceOfferId =>
            this.addToCard(Number(priceOfferQuantity), false, priceOfferId)
          }
          priceOffers={priceOffers}
          selectedQuantity={Number(priceOfferQuantity)}
        />
        <PopUpWrapper
          display={showAdd}
          message={__('Pridať do košíka')}
          small
          onClose={() =>
            this.setState(
              {
                showAdd: false,
              },
              () => closeCallBack(),
            )
          }
          onEscClose={() =>
            this.setState(
              {
                showAdd: false,
              },
              () => closeCallBack(),
            )
          }
        >
          {showAdd && (
            <ProductQuantitySelect
              loading={addLoading}
              defaultQuantity={this.props.defaultQuantity}
              items={product ? product.Unit_of_Measure : []}
              onSubmit={quantity => this.addToCard(Number(quantity))}
              handleKeyDown={(e, quantity) =>
                this.handleKeyDown(e, Number(quantity))
              }
            />
          )}
        </PopUpWrapper>

        <AlertPopup
          alert
          fullWidth={false}
          display={maxSaleQuantity > -1}
          text={`${__(
            'Produkt vo výpredaji je dostupný v maximálnom počte kusov:',
          )} ${maxSaleQuantity}`}
          alignUnderHeader
          onSubmit={() => {
            this.setState({ maxSaleQuantity: -1, error: false }, () =>
              closeCallBack(),
            );
          }}
          onDismiss={() =>
            this.setState({ maxSaleQuantity: -1, error: false }, () =>
              closeCallBack(),
            )
          }
          onClose={() =>
            this.setState({ maxSaleQuantity: -1, error: false }, () =>
              closeCallBack(),
            )
          }
        />
        <AlertPopup
          question
          fullWidth={false}
          display={error}
          text={error}
          subText={__('Prajete si pridať ďalšie kusy?')}
          alignUnderHeader
          onSubmit={() => {
            this.setState({ error: false }, () => {
              this.addToCard(quantityToForcedAdd, true);
            });
          }}
          onDismiss={() =>
            this.setState(
              {
                error: false,
              },
              () => closeCallBack(),
            )
          }
          onClose={() =>
            this.setState(
              {
                error: false,
              },
              () => closeCallBack(),
            )
          }
        />
        <AlertPopup
          question
          fullWidth={false}
          display={compError}
          text={compError}
          subText={__('Prajete si pridať ďalšie kusy?')}
          alignUnderHeader
          onSubmit={() => {
            this.setState({ compError: false }, () => {
              this.addComplementarsToCard(
                compToAdId,
                quantityToForcedCompAdd,
                true,
              );
            });
          }}
          onDismiss={() =>
            this.setState(
              {
                compError: false,
              },
              () => closeCallBack(),
            )
          }
          onClose={() =>
            this.setState(
              {
                compError: false,
              },
              () => closeCallBack(),
            )
          }
        />
        <PopUpWrapper
          display={showComplementarsProducts}
          message={__('Komplementárne produkty')}
          onClose={() =>
            this.setState({
              showComplementarsProducts: false,
            })
          }
          onEscClose={() =>
            this.setState({
              showComplementarsProducts: false,
            })
          }
        >
          <ComplementarsWrapper>
            <Label style={{ marginBottom: rem(15) }}>
              {__('K produktu, ktorý ste pridali do objednávky odporúčame:')}
            </Label>

            <Complementars
              loading={complementaryLoading}
              data={complementarsProducts}
              cartItemsIds={cartItemsIds}
              cartItems={cartItems}
              quantity={addedQuantity}
              addComProductToCard={(productId, quantityToAdd) =>
                this.addComplementarsToCard(productId, quantityToAdd)
              }
            />
          </ComplementarsWrapper>
        </PopUpWrapper>
      </Wrapper>
    );
  }
}

AddToCartWidget.propTypes = {
  product: PropTypes.shape({}),
  colorCode: PropTypes.string,
  toningSystemId: PropTypes.string,
  colorCardId: PropTypes.string,
  closeCallBack: PropTypes.func,
  callback: PropTypes.func,
  defaultQuantity: PropTypes.number,
  priceOffers: PropTypes.arrayOf({}),
  catalogProductParams: PropTypes.arrayOf({}),
};

AddToCartWidget.defaultProps = {
  product: null,
  colorCode: undefined,
  toningSystemId: undefined,
  colorCardId: undefined,
  closeCallBack: () => {},
  callback: () => {},
  defaultQuantity: -1,
  priceOffers: [],
  catalogProductParams: null,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(AddToCartWidget);



// WEBPACK FOOTER //
// ./src/Components/AddToCartWidget/index.jsx